import {
    APP_INITIALIZER,
    ApplicationRef,
    createComponent,
    EmbeddedViewRef,
    EnvironmentInjector,
    Provider,
    Type
} from '@angular/core';
import {ConfigureFeatherIconService} from "./images/configure-feather-icon.service";
import {
    CustomFeatureIconsComponent,
    ICustomFeatureIconsComponent
} from "../components/custom-feature-icons/custom-feature-icons.component";

export const CustomFeatherIconProvider: Provider = {
    provide: APP_INITIALIZER,
    multi: true,
    deps: [ApplicationRef, EnvironmentInjector, ConfigureFeatherIconService ],
    useFactory: (
        appRef: ApplicationRef,
        environmentInjector: EnvironmentInjector,
        configureFeatherIconService: ConfigureFeatherIconService) => () => {

        // Helper function to create the icon component instance
        const createDynamicComponent = (component: Type<ICustomFeatureIconsComponent>) => {
            const componentRef = createComponent(component, {
                environmentInjector: environmentInjector
            });
            appRef.attachView(componentRef.hostView);
            return componentRef;
        };

        const componentRef = createDynamicComponent(CustomFeatureIconsComponent);
        const domElem = (componentRef.hostView as EmbeddedViewRef<ICustomFeatureIconsComponent>).rootNodes[0] as HTMLElement;

        // Collect svg icons from component
        const svgs = domElem.getElementsByTagName('svg');

        // Register each SVG into Feather icon lib
        Array.from(svgs).forEach((svg, index) => {
            const iconName = svg.getAttribute('data-icon-name') || `dynamic-icon-${index}`;
            configureFeatherIconService.registerIcon(iconName, svg.outerHTML);
        });

        // SVG component is not needed any more - cleaning up
        appRef.detachView(componentRef.hostView);
        componentRef.destroy();
    }
}
